/* eslint-disable */
import { FIELD } from "@/data/constants";

export default [
  {
    fieldType: FIELD.TEXT.FIELDSETHEADING,
    name: "medicareTitle",
    label: "Medicare card"
  },
  {
    fieldType: FIELD.TEXT.PARAGRAPH,
    name: "medicareIntroduction",
    description: [
      "Enter all fields as they appear on the Medicare card."
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_medicaredvs_nameOnCard",
    label: "Full name",
    fieldRequired: true,
    validation: { required: true, max: 70, regex: /^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]+$/ },
    hint: "Enter exactly as it appears on your card (e.g. Helen Chan)."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Date of birth",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATE,
    name: "greenid_medicaredvs_dob",
    label: "Date of birth",
    disabled: true,
    hint: "For example, 31 3 1979",
    validation: { required: true },
    fromYear: 1900,
    toYear: 2021
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.RADIO,
    name: "greenid_medicaredvs_cardColour",
    label: "Card colour",
    halfWidth: false,
    fieldRequired: true,
    options: [
      { text: "Green", value: "G" },
      { text: "Blue", value: "B" },
      { text: "Yellow", value: "Y" }
    ]
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_medicaredvs_number",
    label: "Medicare card number",
    type: "text",
    fieldRequired: true,
    validation: { required: true, min: 10, max: 10 },
    hint: "The 10 digit number on your card."
  },
  {
    fieldType: FIELD.INPUT.TEXT,
    name: "greenid_medicaredvs_individualReferenceNumber",
    label: "Reference number",
    fieldRequired: true,
    validation: { required: true, max: 1 },
    hint: "The number next to your name."
  },
  {
    fieldType: FIELD.TEXT.FIELDDATEHEADING,
    label: "Expiry date",
    fieldRequired: true
  },
  {
    fieldType: FIELD.INPUT.DATEMEDICARE,
    name: "greenid_medicaredvs_expiry",
    label: "Expiry date",
    hint: "For example, 12 9 2022",
    validation: { required: true },
    fromYear: new Date().getFullYear(),
    toYear: 2032
  },
  {
    fieldType: FIELD.FORM.DIVIDER
  },
  {
    fieldType: FIELD.INPUT.CHECK,
    name: "greenid_medicaredvs_tandc",
    label: "Authorisation/Consent",
    validation: { required: true },
    options: [
      {
        value: "on",
        text: "I confirm that I am authorised to provide the personal details presented and I consent to my information being checked with the document issuer or official record holder via third party systems for the purpose of confirming my identity."
      }
    ]
  }
];